import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { styles } from './styles'
import OppiziSvg from '../../../../Assets/Images/icons/OppiziSvg'

const useStyles = makeStyles(styles)

export const ExternalOAuthSuccess = ({ toolName }) => {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <div className={classes.logoContainer}>
        <OppiziSvg className={classes.logo} />
        <span className={classes.logoText}>Frames</span>
      </div>

      <h1 className={classes.heading}>
        You can already close this tab and go back to {toolName}
      </h1>

      <p className={classes.subtext}>
        If you experience any issues using the plugin, please contact support at{' '}
        <a href="mailto:support@oppizi.com" className={classes.supportLink}>
          support@oppizi.com
        </a>
      </p>
    </div>
  )
}

export default ExternalOAuthSuccess
